// extracted by mini-css-extract-plugin
export default {"popularCities":"xTIyYZL_x8ZiRhNNU2uZ"};